import { createContext } from "react";

interface Organization {
  organizationId: string | null;
}
const OrganizationContext = createContext<Organization>({ organizationId: null });

export default OrganizationContext;
